import { Spin } from 'antd';
import { useEffect, useState } from 'react';
import usePermissions from 'src/app/hooks/usePermissions';
import { initDB } from 'src/app/pages/HomePage/db';

const DashboardDBInitializer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [dbReady, setDbReady] = useState(false);
  const { permissions } = usePermissions();

  useEffect(() => {
    if (permissions) {
      initDB(permissions).then(() => setDbReady(true));
    }
  }, [permissions]);

  if (!dbReady) return <Spin />;

  return children;
};

export default DashboardDBInitializer;
